export const INSTITUTION_TYPES = [
  { id: "LAB", name: "Laboratoire" },
  { id: "UNIV", name: "Université" },
  { id: "HOSP", name: "Hôpital" },
  { id: "CLIN", name: "Clinique" },
  { id: "PHARM", name: "Pharmacie" },
  { id: "RES", name: "Centre de Recherche" },
  { id: "OTHER", name: "Autre" },
];

export const LANGUAGES = [
  { id: "FR", name: "Français" },
  { id: "EN", name: "English" },
  { id: "ES", name: "Español" },
  { id: "AR", name: "العربية" },
];

export const GENDERS = [
  { value: "M", label: "Homme" },
  { value: "F", label: "Femme" },
];

export const TITLES = [
  { value: "PROF", label: "Professeur" },
  { value: "DOC", label: "Docteur" },
  { value: "ETU", label: "Etudiant" },
  { value: "OTHER", label: "Autre" },
];

export const MEDICATION_TYPES = [
  { value: "PRINCEPS", label: "Princeps" },
  { value: "GENERIQUE", label: "Générique" },
  { value: "BIOSIMILAIRE", label: "Biosimilaire" },
];

export const DOSE_UNITS = [
  { value: "MG", label: "mg" },
  { value: "ML", label: "ml" },
  { value: "G", label: "g" },
  { value: "MCG", label: "mcg" },
  { value: "PERCENT", label: "%" },
];

export const DISPENSATION_OPTIONS = [
  { value: "ORDONNANCE", label: "Ordonnance" },
  { value: "CONSEIL", label: "Conseil" },
  { value: "HOPITAL", label: "Hôpital" },
];

export const PUBLIC_CIBLE_OPTIONS = [
  { value: "ADULTE", label: "Adulte" },
  { value: "ENFANT", label: "Enfant" },
  { value: "PERSONNES_AGEES", label: "Personnes Âgées > 65 ans" },
  { value: "FEMMES_ENCEINTES", label: "Femmes enceintes" },
];

export const ORIGIN_OPTIONS = [
  { value: "LOCAL", label: "Fabriqué localement" },
  { value: "IMPORTED", label: "Importé" },
];

export const TABLEAU_LISTE_OPTIONS = [
  { value: "A", label: "Tableau A" },
  { value: "B", label: "Tableau B" },
  { value: "C", label: "Tableau C" },
];

export const AVAILABILITY_OPTIONS = [
  { value: "DISPONIBLE", label: "Disponible" },
  { value: "RUPTURE", label: "Rupture" },
  { value: "TENSIONS", label: "Tensions de stock" },
];

export const STATUS_OPTIONS = [
  { value: "COMMERCIALISE", label: "Commercialisé" },
  { value: "NON_COMMERCIALISE", label: "Non commercialisé" },
  { value: "RETIRE", label: "Retiré du marché" },
  { value: "SUSPENDU", label: "Suspendu du marché" },
];

export const ADMINISTRATION_ROUTE_OPTIONS = [
  { value: "orale", label: "Orale" },
  { value: "injectable", label: "Injectable" },
  { value: "intraveineuse", label: "Intraveineuse" },
  { value: "topique", label: "Topique" },
  { value: "inhalation", label: "Inhalation" },
  { value: "rectale", label: "Rectale" },
  { value: "ophtalmique", label: "Ophtalmique" },
  { value: "nasale", label: "Nasale" },
  { value: "transdermique", label: "Transdermique" },
  { value: "sublinguale", label: "Sublinguale" },
];

export const LEVEL_OPTIONS = [
  { id: "debutant", name: "Débutant", color: "#4CAF50", bgcolor: "#E8F5E8" },
  {
    id: "intermediaire",
    name: "Intermédiaire",
    color: "#FF9800",
    bgcolor: "#FFF3E0",
  },
  { id: "avance", name: "Avancé", color: "#2196F3", bgcolor: "#E3F2FD" },
  { id: "expert", name: "Expert", color: "#9C27B0", bgcolor: "#F3E5F5" },
];
